import React from 'react'
import Panel from '../Panel'
import { dGet } from '@core/utils'
import LabelText from '../LabelText'

/**
 *  不再跟进卡片
 */
const NotFollowCard = ({ item, operator }) => {
  const { reason } = dGet(item, 'notfollow_card', {})

  return (
    <Panel
      icon="//qnm.hunliji.com/o_1d8n8ueul1ji83dv1qi52ga19na12.png"
      item={item}
    >
      <LabelText label="理由" block>
        {reason}
      </LabelText>

      <LabelText label="操作人" block>
        {operator}
      </LabelText>
    </Panel>
  )
}

export default NotFollowCard
